import React from 'react';
import { Button, Icon, Table, Header, Segment, Loader, Popup, Grid } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';

import { fetchMarks } from '../../Lookups/util';
import {ExportReactCSV} from "../../util/ExportCSV";
import SearchTableData from "../../util/SearchTableData";
import PaginationFront from "../../util/PaginationFront";
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;


export default class ExamGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            marks: [],

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: true,

            isLoading: false,
            results: [],
            value: '',

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            excelData: []

        };

        this.filtersOff = this.filtersOff.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.getAllStudents = this.getAllStudents.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.deleteGrade = this.deleteGrade.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        axios.all([fetchMarks()])
            .then(axios.spread((markRes) => {
                const marks = markRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName, passed: el.passed
                }));

                this.setState({ marks });
            }))
            .then(res => this.getAllStudents())
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch marks or study types');
            });
    }

    getAllStudents() {
        axios.get(`/exams/student-marks/${parseInt(localStorage.getItem('gradedActivityId'), 10)}`)
            .then(res => {
                const data = res.data.map(el => ({
                    ...el,
                    grade: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null,
                    examDateFormated: moment(el.examDate).format('D. M. YYYY.'),
                    inputDateFormated: el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : ''
                }));
                this.setState({ data, loading: false });

                const excelData = res.data.map(el => ([
                    { value: el.studentLastName},
                    { value: el.studentFirstName },
                    { value: el.index },
                    { value: el.departments ? el.departments[0].name: '' },
                    { value: el.studyProgramBasicName },
                    { value: el.studyProgramName },
                    { value: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null },
                    { value: el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : '' },
                ]));
                this.setState({excelData: excelData});
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch students');
            });
    }

    deleteGrade(optLock, studentMarkId, studentGradedActivityId, studentGradedActivityOptLock) {
        let obj = {
            id: studentMarkId,
            optLock,
            studentGradedActivity: {
                id: studentGradedActivityId,
                optLock: studentGradedActivityOptLock
            }
        };

        axios.delete('/student-exams/delete-grade-and-registration', { data: obj })
            .then(res => {
                toast('Ocjena je uspješno obrisana.');
                this.getAllStudents();
            })
            .catch(err => {
                toast('Došlo je do greške! Ocjena nije obrisana.');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }

        if (this.state.results.length !== 0) {
            return this.state.results;
        }

        return this.state.data;
    }


    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }


    getFilterData(firstName, lastName, index, studyProgramName, studyTypeId, markId, canceled) {
        const docFilter = {
            firstName,
            lastName,
            index,
            studyProgramName,
            studyTypeId,
            markId,
            canceled
        };

        if (this.state.showFilterMode) {
            if (firstName || lastName || index || studyProgramName || studyTypeId || markId) {
                this.setState({ showFiltersOnButton: true, showFilterMode: false });
            } else {
                toast(<FormattedMessage id="professorInputGrades.toastFilter" />);
            }
        }

        axios.post(`/professor/students/${parseInt(localStorage.getItem('gradedActivityId'), 10)}/true`, { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    grade: el.markId ? this.state.marks.find(e => e.key === el.markId).text : '',
                }));
                this.setState({ filterData });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast(<FormattedMessage id="professorInputGrades.toastFilterFailed" />);
            });
    }


    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.state.data;
    }

    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    getStudents() {
        let obj = {
            gradedActivityId: parseInt(localStorage.getItem('gradedActivityId'), 10),
            language: 'bs'
        };
        axios({
            method: 'post',
            url: '/documents/exam-marks',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }


    render() {

        const headersForExport = [
            { label: 'Prezime', key: 'studentLastName' },
            { label: 'Ime', key: 'studentFirstName' },
            { label: 'Index', key: 'index' },
            { label: 'Ocjena', key: 'grade' },
            { label: 'Odsjek', key: 'departments[0].name' },
            { label: 'Studijski program', key: 'studyProgramBasicName' },
            { label: 'Plan i program', key: 'studyProgramName' },
            { label: 'Datum ispita', key: 'examDateFormated' },
            { label: 'Datum unosa ocjene', key: 'inputDateFormated' },
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 150 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Odsjek', width: { wpx: 300 } },
                    { title: 'Studijski program', width: { wpx: 300 } },
                    { title: 'Plan i program', width: { wpx: 300 } },
                    { title: 'Ocjena', width: { wpx: 200 } },
                    { title: 'Datum unosa ocjene', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);



        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                {currentPosts.length ?
                    <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={15} >
                                        <span>
                                            <Grid stackable columns={3} >

                                                         <Grid.Column width={12}>
                                            <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['studentLastName', 'studentFirstName', 'index', 'studyProgramName', 'inputDateFormated', 'examDateFormated', 'grade']} />
                                            </Grid.Column>
                                                      <Grid.Column width={2} style={{paddingRight: '5px'}}>
                                                             {localStorage.getItem('gradedActivityName') !== 'komisijski ispit' &&

                                            <Popup
                                                trigger={
                                                    <Button
                                                        animated="vertical"
                                                        floated="right"
                                                        color="red"
                                                        basic
                                                        fluid
                                                        onClick={this.getStudents}
                                                    >
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            PDF
                                                        </Button.Content>
                                                    </Button>
                                                }
                                                content="Preuzmi spisak u PDF-u"
                                                hideOnScroll
                                                position="top center"
                                            />}
                                                          </Grid.Column>
                                                      <Grid.Column width={2} style={{paddingLeft: '5px'}}>
                                            {this.getDataToRender() &&
                                            <ExcelFile filename="Spisak studenata sa ocjenama" element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={multiDataSet} name="Studenti" />
                                            </ExcelFile>
                                            // <ExportReactCSV
                                            //     color="green"
                                            //     csvData={this.state.data}
                                            //     headers={headersForExport}
                                            //     floated="right"
                                            //     fileName="Spisak studenata sa ocjenama"
                                            // />
                                            }

 </Grid.Column>
                                                </Grid>

                                        </span>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell colSpan={1} width={1}>
                                    R. br.
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={2} width={2}>*/}
                                {/*    Index*/}
                                {/*</Table.HeaderCell>*/}
                                <Table.HeaderCell colSpan={4}>
                                    Prezime i ime studenta/ice
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>
                                    Odsjek
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={4}>
                                    Studijski program
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>
                                    Ocjena
                                </Table.HeaderCell>
                                {/*<Table.HeaderCell colSpan={2}>*/}
                                {/*    Datum ispita*/}
                                {/*</Table.HeaderCell>*/}
                                <Table.HeaderCell colSpan={2}>
                                    Datum unosa ocjene
                                </Table.HeaderCell>
                                {/* <Table.HeaderCell/> */}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {currentPosts.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell colSpan={1} verticalAlign="middle">
                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                </Table.Cell>
                                {/*<Table.Cell colSpan={2} verticalAlign="middle">*/}
                                {/*    {el.index}*/}
                                {/*</Table.Cell>*/}
                                <Table.Cell colSpan={4} verticalAlign="middle">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Row verticalAlign="middle">
                                            <Grid.Column width="10">
                                                <span >{el.studentLastName} {el.studentFirstName}</span>
                                            </Grid.Column>
                                            <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                {/*<span style={{ color: '#a6a4a1' }}>{el.index}</span>*/}
                                                <span style={{ color: '#a6a4a1' }}>{el.index}</span>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                    {/*{el.studentLastName} {el.studentFirstName}*/}
                                </Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle">
                                    {el.departments.map(el => (<div>{el.name}</div>))}
                                </Table.Cell>
                                <Table.Cell colSpan={4} verticalAlign="middle">
                                        <strong>{el.studyProgramBasicName}</strong> | {el.studyProgramName}
                                    {/*{el.studyProgramName}*/}
                                </Table.Cell>
                                <Table.Cell colSpan={2} verticalAlign="middle">
                                    {el.grade}
                                </Table.Cell>
                                {/*<Table.Cell colSpan={2} verticalAlign="middle">*/}
                                {/*    {moment(el.examDate).format('D. M. YYYY.')}*/}
                                {/*</Table.Cell>*/}
                                <Table.Cell colSpan={2} verticalAlign="middle">
                                    {el.inputDate ? moment(el.inputDate).format('D. M. YYYY.') : ''}
                                </Table.Cell>
                                {/* <Table.Cell verticalAlign="middle" textAlign='center'> */}
                                {/* <Button color='red' basic='true' onClick={()=>this.deleteGrade(el.optLock, el.studentMarkId, el.studentGradedActivityId, el.studentGradedActivityOptLock)}>Brisanje ocjene</Button> */}
                                {/* </Table.Cell> */}

                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : this.state.showFiltersOnButton ?
                        'Filtriranje je uključeno! Nema ocijenjenih studenata.'
                        : 'Nema ocijenjenih studenata.'

                }

                {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/ExamGrades.js